import { render, staticRenderFns } from "./PdfElement.vue?vue&type=template&id=c494c1e8&scoped=true&"
import script from "./PdfElement.vue?vue&type=script&lang=ts&"
export * from "./PdfElement.vue?vue&type=script&lang=ts&"
import style0 from "./PdfElement.vue?vue&type=style&index=0&id=c494c1e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c494c1e8",
  null
  
)

export default component.exports